import {BaseComponent} from '../../abstract/base.component';
import {ApiErrorModel} from '../../data/model/ApiErrorModel/api-error.model';
import { Directive } from '@angular/core';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class PasswordResetAction extends BaseComponent {
  // protected _sigInUrl: string;
  protected _resetPassword: string;
  protected abstract passForgotPasswordResponse(res);
  protected abstract passForgotPasswordError(error: ApiErrorModel);
  // userSignIn(postBody) {
  //   this.dataManager.login(this._sigInUrl, postBody)
  //     .subscribe(
  //       res => this.passSiginResponse(res),
  //       error => {
  //         this.networkErrorHandler(error.error);
  //         this.passSignInError(error.error);
  //       }
  //     );
  // }
  resetPassword(postBody) {
    this.dataManager.postRequestMixed(this._resetPassword, postBody)
      .subscribe({
        next: (response) => {
          if (response.status === 200) {
            this.passForgotPasswordResponse(response);
          }
        },
        error: (error) => {
          const errorJson = JSON.parse(error.error);
          this.networkErrorHandler(errorJson);
          this.passForgotPasswordError(errorJson);
        }
      });
  }
}
